module.exports = __webpack_public_path__ + "img/banner.f2bb6b14.jpg";